<div class="flex--column">
  <div class="content">
    <div class="flex flex--row full-width flex--justify-space-between flex--align-center header">
      <span class="calculated-on">
        <span class="text--bold">{{ 'blightV2.shared.calculatedOn' | translate }}</span>
        @if (lastCalculatedOn()) {
          <span class="text--gray" data-test="last-calculated-on">{{
            lastCalculatedOn() | date: 'short' : undefined : locale
          }}</span>
        } @else {
          <span class="text--gray" data-test="last-calculated-on">{{
            'blightV2.shared.notYetCalculated' | translate
          }}</span>
        }
      </span>
      <div class="flex--row flex--align-center table-toolbar-button-group">
        <app-recalculate-button
          (recalculate)="onRecalculate()"
          [disabled]="isRecalculationDisabled()"
          [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
          [isLoading]="store.isBlightCropFieldsSyncing()"
          [label]="'blightV2.shared.recalculateAdviceAll' | translate"
          [loadingLabel]="'blightV2.shared.recalculating' | translate"
        />
      </div>
    </div>

    <app-blight-action-menu #actionMenu [advices]="selectedAdvices()" />

    <app-disease-overview-table
      (adviceTitleClick)="onCropFieldClick($event)"
      (selectedCropFieldsChanged)="onSelectedCropFieldsChange($event)"
      (selectedDatesChanges)="onSelectedDatesChange($event)"
      (cropFieldVisibilityChanged)="onCropFieldVisibilityChanged($event)"
      [actionMenu]="actionMenu.menu"
      [advices]="advices()"
      [diseaseCropFields]="diseaseCropFields()"
      [minimalDate]="store.blightMinAdviceDate()"
      [cropYear]="store.cropYear()"
      [selectedDates]="store.selectedDates()"
    />
  </div>
  <div class="flex--row full-width flex--justify-end">
    <app-blight-advice-overview-legend />
  </div>
</div>
